// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAAedpeyLHXavcG7lkuC2ZtWQGEfh86gV4",
  authDomain: "dairyerp-e0eb6.firebaseapp.com",
  projectId: "dairyerp-e0eb6",
  storageBucket: "dairyerp-e0eb6.firebasestorage.app",
  messagingSenderId: "176931609554",
  appId: "1:176931609554:web:293505aabd8e38c84a460b",
  measurementId: "G-GE8C39K4SR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
